import React from 'react';
import { CarouselItems } from '../HeroCarousel';

export type HeroImageProps = {
    alt?: string;
} & Pick<
    CarouselItems,
    'croppedLogoUrl480' | 'croppedLogoUrl600' | 'croppedLogoUrl940'
>;

export const HeroImage = ({
    croppedLogoUrl480,
    croppedLogoUrl600,
    croppedLogoUrl940,
    alt,
}: HeroImageProps) => {
    return (
        <picture data-testid="hero-image">
            <source
                srcSet={`
                    ${croppedLogoUrl480} 480w,
                    ${croppedLogoUrl600} 600w,
                    ${croppedLogoUrl940} 940w
                `}
                sizes="
                    (max-width:480px) 480px,
                    (max-width:600px) 600px,
                    940px
                "
            />
            <img width="600" height="300" alt={alt} src={croppedLogoUrl600} />
        </picture>
    );
};
